// extracted by mini-css-extract-plugin
export default {"results":"styles_results__MdJvV","result":"styles_result__pXeTx","hint":"styles_hint__snDeg"};